import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';

import { Table } from 'components/MRT';
import { MarketLinkIcon } from 'components/icons';
import { useRouteUtils } from 'routes';
import { NextLink } from 'components';
import { MarketsTableData } from 'api/selectors/pages/getMarketsTableData';
import { ProductSlug, VersionSlug, NetworkSlug } from 'domain/types';

import { columns } from './tableColumns';

export function MarketsTable({
  tableData,
  productSlug,
  versionSlug,
  network,
}: {
  tableData: MarketsTableData[];
  productSlug: ProductSlug;
  versionSlug: VersionSlug;
  network: NetworkSlug;
}) {
  const pageSize = 10;
  const { redirectTo } = useRouteUtils();
  const enablePagination = tableData.length > pageSize;

  return (
    <Table<MarketsTableData>
      initialState={{
        density: 'compact',
        columnVisibility: { lowSupply: false },
        pagination: { pageIndex: 0, pageSize },
        columnOrder: [
          'rating',
          'name',
          'mrt-row-actions',
          'utilizationRatio',
          'impactCost',
          'totalBorrow',
          '24Hborrow',
          'totalCollateral',
          '24Hcollateral',
          'supplyTvl',
          '24Htvl',
          'assets',
          'lowSupply',
        ],
      }}
      autoPinningColumns={['rating', 'name', 'mrt-row-actions']}
      data={tableData}
      columns={columns}
      enableRowActions
      withFullScreenButton
      enablePagination={enablePagination}
      enablePinning={false}
      enableTopToolbar={false}
      renderRowActions={({ row }) => (
        <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'nowrap', gap: '8px' }}>
          <NextLink
            {...redirectTo.marketAssets({
              productSlug,
              versionSlug,
              network,
              marketId: row.original.marketId,
            })}
          >
            <Tooltip title="View Market analytics">
              <IconButton sx={{ fontSize: '0.85rem' }}>
                <MarketLinkIcon fontSize="inherit" />
              </IconButton>
            </Tooltip>
          </NextLink>
        </Box>
      )}
    />
  );
}
